import { render, staticRenderFns } from "./CpJlLayout.vue?vue&type=template&id=22f32f68&scoped=true&"
import script from "./CpJlLayout.vue?vue&type=script&lang=js&"
export * from "./CpJlLayout.vue?vue&type=script&lang=js&"
import style0 from "./CpJlLayout.vue?vue&type=style&index=0&id=22f32f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f32f68",
  null
  
)

export default component.exports